const Copyright = () => {
    return (<div className="text-center copyright">
        <small className="text-light">Copyright {new Date().getFullYear()} &copy; insurEco System</small>
    </div>)
}

export default Copyright;